import React from 'react';
import { Routes, Route } from 'react-router';
import EditAssignment from './EditAssignment';
import Main from '../ManageAssign/Main';
import AdminAssessments from './AdminAssessments';
import Activities from './Activities';
import Assignment from './Assignments';
import Index from './Index';
import { AssignmentProvider } from '../../context';
import GradeCrQuestions from '../ManageAssign/components/AssignmentResults/CRGrading/gradeCrQuestions';
import MoreActions from '../MoreActions/main';
import CreatePublicAssignment from './CreatePublicAssignment';
import GoogleAccess from '../../../../../src/components/GoogleAccess/index';

const main = () => {
  return (
    <AssignmentProvider>
      <Routes>
        <Route path="/" element={<Index />}>
          <Route index element={<Assignment />} />
          <Route path="activities/*" element={<Activities />} />
          <Route path="admin_assessments" element={<AdminAssessments />} />
        </Route>
        <Route path=":assignmentId/*" element={<MoreActions />} />
        <Route path=":Id/manage_assign/*" element={<Main />} />
        <Route path=":assignmentId/grade_constructiveResponses" element={<GradeCrQuestions />} />
        <Route path=":Id/edit_assignment/*" element={<EditAssignment />} />
        <Route path="create_public_assignment" element={<CreatePublicAssignment />} />
        <Route path="google_classes" element={<GoogleAccess/>} />
      </Routes>
    </AssignmentProvider>
  );
};

export default main;
